import $ from 'jquery';
import CONSTANT from '../../common/js/_constant';
import Chart from 'chart.js/auto';
import { paddingLeftPlugin } from './customChartPlugin';

const ppfCalculator = {
    variables: {
        ppfCalculatorWrapper: '.ppf__calculator--wrapper',
        ppfCalculatorDrowpdownText: '.ppf__calculator__dropdown--text',
        ppfCalculatorSelectEl: '.ppf__calculator--select',
        frequencySelectText: '{investmentFrequency}',
        ppfAmount: '{ppfAmount}',
        frequencyText: '{investmentFrequency}',
        ppfAmountText: '{ppfAmount}',
        ppfTime: '{time}',
        ppfUserName: '{customerName}',
        ppfPhoneNumber: '{phoneNumber}',
        ppfCalculatorInvestment: '.ppf__calculator__amount--text',
        ppfSelectIcon: '.select__arrow',
        ppfCalculatorAmount: '.ppf__calculator--amount',
        ppfCalculatorTime: '.ppf__calculator--time',
        ppfCalculatorUserText: '.ppf__calculator__userdetail--text',
        ppfCalculatorUserName: '.ppf__calculator--name',
        ppfCalculatorMobNo: '.ppf__calculator--mob',
        ppfCalculatorForm: '.ppf__calculator--form',
        ppfCalculatorFormSubmit: '.ppf__calculator--submit',
        ppfGraphEl: '.ppf__calculator--canvas',
        ppfChart: null,
        ppfMaturityHeading: '.ppf__calculator__maturity--heading',
        ppfMaturityAmount: '.ppf__calculator__maturity--amount',
        ppfCalculatorReset: '.ppf__calculator--resettext',
        ppfuserName: '{name}',
        ppfPrincipal: [],
        ppfInterest: [],
        ppfLabels: [],
        ppfPeriodType: 'yearly',
        ppfMinDuration: 15,
        ppfData: [],
        ppfMinAmount: 500,
        ppfChart: null,
        ppfMaturity: 0,
        frequencyLimits:{
            'monthly': { min: 42, max: 12500 },
            'quarterly': { min: 125, max: 37500 },
            'half-yearly': { min: 250, max: 75000 },
            'yearly': { min: 500, max: 150000 }
        },
        name:null,
        mobileNumber:null
    },
    methods: {
        createDropDown: function (ppfCalculatorEl) {
            /* eslint-disable @typescript-eslint/no-this-alias */
            const $self = this;
            $(ppfCalculatorEl).each(function () {
                $self.replaceSelect(this);
                $self.replaceInputs(this);
                $self.getSelectedTime(this);
                $self.changeInvestmentInput(this);
                $self.validateTimeInput(this);
                $self.replaceUserInputs(this);
                $self.validateUserNameInput(this);
                $self.validateMobileNumberInput(this);
                $self.ppfFormSubmit(this);
                $self.reCalculate(this);
            });
            /* eslint-disable @typescript-eslint/no-this-alias */
        },
        replaceSelect: function (el) {
            const selectInput = $(el).find(ppfCalculator.variables.ppfCalculatorSelectEl).removeClass('d-none').detach();
            const replaceText = ppfCalculator.variables.frequencySelectText;
            const replaceTextEl = $(el).find(ppfCalculator.variables.ppfCalculatorDrowpdownText);
            const selectIcon = $(el).find(ppfCalculator.variables.ppfSelectIcon).removeClass('d-none').detach();
            if (replaceTextEl.length) {
                const replacedTextEl = replaceTextEl.html().replace(replaceText, `<span class="d-inline-flex align-items-center position-relative">${selectInput.prop('outerHTML')}${selectIcon.prop('outerHTML')}</span>`);
                replaceTextEl.html(replacedTextEl);
            }
        },
        replaceInputs: function (el) {
            const ppfInvestmentInputs = $(el).find(ppfCalculator.variables.ppfCalculatorInvestment);
            const ppfAmount = $(el).find(ppfCalculator.variables.ppfCalculatorAmount).removeClass('d-none').parent().detach();
            const ppfTime = $(el).find(ppfCalculator.variables.ppfCalculatorTime).removeClass('d-none').parent().detach();
            if (ppfInvestmentInputs.length) {
                const replacedInputs = ppfInvestmentInputs.html().replace(ppfCalculator.variables.frequencyText, `<span class="text-blue-500 ppf__time--text">${$(ppfCalculator.variables.ppfCalculatorSelectEl).val()}</span>`)
                    .replace(ppfCalculator.variables.ppfAmount, ppfAmount.prop('outerHTML'))
                    .replace(ppfCalculator.variables.ppfTime, ppfTime.prop('outerHTML'));
                ppfInvestmentInputs.html(replacedInputs);
            }
        },
        replaceUserInputs: function (el) {
            const ppfUserDetailText = $(el).find(ppfCalculator.variables.ppfCalculatorUserText);
            const ppfUserInputs = $(el).find(ppfCalculator.variables.ppfCalculatorUserName).removeClass('d-none').parent().detach();
            const ppfMobNoInputs = $(el).find(ppfCalculator.variables.ppfCalculatorMobNo).removeClass('d-none').parent().detach();
            if (ppfUserDetailText.length) {
                const replacedInputs = ppfUserDetailText.html().replace(ppfCalculator.variables.ppfUserName, ppfUserInputs.prop('outerHTML'))
                    .replace(ppfCalculator.variables.ppfPhoneNumber, ppfMobNoInputs.prop('outerHTML'));
                ppfUserDetailText.html(replacedInputs);
            }
        },
        getSelectedTime: function (el) {
            const selectEl = $(el).find(ppfCalculator.variables.ppfCalculatorSelectEl);
            selectEl.on(CONSTANT.eventsListners.CHANGE, function () {
                const selectedFrequency = $(this).val().toLowerCase();
                $(el).find('.ppf__time--text').text(selectedFrequency);
                $(el).find(ppfCalculator.variables.ppfCalculatorAmount).removeClass('error__active');
                $(el).find(ppfCalculator.variables.ppfCalculatorTime).removeClass('error__active');

            });
        },
        changeInvestmentInput: function (el) {
            const ppfInvestmentInputs = $(el).find(ppfCalculator.variables.ppfCalculatorAmount);
            /* eslint-disable @typescript-eslint/no-this-alias */
            const $self = this;
            const formattedValue = $self.formatNumber(ppfInvestmentInputs.val());
            ppfInvestmentInputs.val(formattedValue);
            ppfInvestmentInputs.on(CONSTANT.eventsListners.INPUT, function () {
                const cursorPos = $(this).get(0).selectionStart;
                const numStr = $(this).val().replace(/[^0-9]/g, '');
                let numericValue = parseInt(numStr, 10);
                const selectedFrequency = $(el).find(ppfCalculator.variables.ppfCalculatorSelectEl).val().toLowerCase();
                const { min, max } = ppfCalculator.variables.frequencyLimits[selectedFrequency] || { min: 0, max: Infinity };
                if (isNaN(numericValue)) {
                    numericValue = 0;
                }
                if (numericValue < min) {
                    $(this).addClass('error__active');
                    $(this).siblings('.error').text(`${selectedFrequency} minimum amount should be ${min}`);
                } else if (numericValue > max) {
                    $(this).addClass('error__active');
                    $(this).siblings('.error').text(`${selectedFrequency} maximum amount should be ${max}`)
                }
                else{
                    $(this).removeClass('error__active');
                }
                const formattedNumber = $self.formatNumber(numericValue);
                $(this).val(formattedNumber);
                const endPos = $(this).val().length;
                $(this).get(0).setSelectionRange(cursorPos, endPos);
            })
            /* eslint-disable @typescript-eslint/no-this-alias */
        },
        formatNumber: function (number) {
            const numStr = number.toString().replace(/,/g, '');
            const [integerPart, decimalPart] = numStr.split('.');
            let formattedIntegerPart;
            if (integerPart.length <= 3) {
                formattedIntegerPart = integerPart;
            } else {
                const lastThreeDigits = integerPart.slice(-3);
                const remainingDigits = integerPart.slice(0, -3);
                formattedIntegerPart = remainingDigits
                    .replace(/\B(?=(\d{2})+(?!\d))/g, ',')
                    .concat(lastThreeDigits ? `,${lastThreeDigits}` : '');
            }
            const formattedNumber = decimalPart ? `${formattedIntegerPart}.${decimalPart}` : formattedIntegerPart;
            return formattedNumber;
        },
        validateTimeInput: function (el) {
            $(el).find(ppfCalculator.variables.ppfCalculatorTime).on(CONSTANT.eventsListners.INPUT, function () {
                const $this = $(this);
                let value = $this.val().replace(/[^0-9]/g, '');
                let numericValue = parseInt(value, 10);
                if (isNaN(numericValue) || value === '') {
                   numericValue = 0;
                }
                if (numericValue < 15 || numericValue % 5 !== 0 || numericValue > 50) {
                    $this.addClass('error__active');
                    $this.siblings('.error').text('Duration should be a multiple of 5 and between 15 to 50');
                } else {
                    $this.removeClass('error__active');
                }
                $this.val(numericValue);
            });
        },
        validateUserNameInput: function (el) {
            $(el).find(ppfCalculator.variables.ppfCalculatorUserName).on(CONSTANT.eventsListners.INPUT, function () {
                const $this = $(this);
                let value = $this.val().replace(/[^a-zA-Z\s]/g, '');
                $this.val(value);
                if($this.val().length === 0){
                    $this.addClass('error__active');
                    $this.siblings('.error').text('Name is required');
                }
                else if($this.val().length < 3){
                    $this.addClass('error__active');
                    $this.siblings('.error').text('Name should contain at least 3 characters');
                }
                else{
                    $this.removeClass('error__active');
                }
            });
        },
        validateMobileNumberInput: function (el) {
            $(el).find(ppfCalculator.variables.ppfCalculatorMobNo).on(CONSTANT.eventsListners.INPUT, function () {
                const $this = $(this);
                const mobileValue = $(this).val();
                if (mobileValue.length > 0 && (!/^[6-9][0-9]*$/.test(mobileValue))) {
                    $(this).val(mobileValue.slice(0, -1));
                }
                let value = $this.val().replace(/[^0-9]/g, '');
                if (value.length > 10) {
                    value = value.slice(0, 10);
                }
                $this.val(value);
                // Optional field: an empty box is valid, so clear the error rather
                // than flagging it the moment the user deletes what they typed.
                if (value.length === 0 || /^[6789]\d{9}$/.test(value)) {
                    $this.removeClass('error__active');
                    $this.siblings('.error').text('');
                } else {
                    $this.addClass('error__active');
                    $this.siblings('.error').text('Please enter valid Indian mobile number');
                }
            });
        },
        ppfFormSubmit: function (el) {
            /* eslint-disable @typescript-eslint/no-this-alias */
            const $self = this;
            $(el).find(ppfCalculator.variables.ppfCalculatorForm).on(CONSTANT.eventsListners.SUBMIT, function (e) {
                e.preventDefault();
                // The mobile field is optional, and it is only in the DOM when the
                // author included {phoneNumber} in the Personal Details text (see
                // replaceUserInputs, which detaches it and re-inserts it on that
                // token). So guard on the element existing — .val() on an empty
                // set is undefined, and reading .length off that used to throw and
                // abort the whole submit — and only validate once something is typed.
                const $mobEl = $(el).find(ppfCalculator.variables.ppfCalculatorMobNo);
                const mobVal = ($mobEl.val() || '').trim();
                const userName = $(el).find(ppfCalculator.variables.ppfCalculatorUserName).val();
                if ($mobEl.length && mobVal.length && !/^[6789]\d{9}$/.test(mobVal)) {
                    $mobEl.addClass('error__active');
                    $mobEl.siblings('.error').text('Please enter valid Indian mobile number');
                } else {
                    $mobEl.removeClass('error__active');
                    $mobEl.siblings('.error').text('');
                }

                if(userName.length === 0){
                    $(el).find(ppfCalculator.variables.ppfCalculatorUserName).addClass('error__active');
                    $(el).find(ppfCalculator.variables.ppfCalculatorUserName).siblings('.error').text('Name is required');
                }
                else if(userName.length < 3){
                    $(el).find(ppfCalculator.variables.ppfCalculatorUserName).addClass('error__active');
                    $(el).find(ppfCalculator.variables.ppfCalculatorUserName).siblings('.error').text('Name should contain at least 3 characters');
                }
                else{
                    $(el).find(ppfCalculator.variables.ppfCalculatorUserName).removeClass('error__active');
                }
                if($(el).find('.error__active').length){
                    return;
                }
                const form = $(this).get(0);
                const ppfFormData = new FormData(form);
                const ppfData = Array.from(ppfFormData.entries()).map(([key, value]) => ({ [key]: value }));
                const combinedObject = Object.assign({}, ...ppfData);
                ppfCalculator.variables.ppfData.length > 0 && ppfCalculator.variables.ppfData.splice(0, ppfCalculator.variables.ppfData.length);
                ppfCalculator.variables.ppfData.push(combinedObject);
                const [data] = ppfCalculator.variables.ppfData;
                const {
                    "ppf-amount": ppfAmount,
                    "ppf-duration": ppfDuration,
                    "ppf-time": ppfTime,
                    "ppf-name": ppfName,
                } = data;
                $(el).find("[data-page='1']").addClass('d-none');
                $(el).find("[data-page='2']").removeClass('d-none');
                const firstName = ppfName.split(' ')[0];
                const ppfROI = $(el).data('roi') || 7.1;
                ppfCalculator.variables.ppfMaturity = $self.calculatePPF(ppfDuration, ppfAmount, ppfTime, ppfROI);
                $(el).find(ppfCalculator.variables.ppfMaturityAmount).text(`₹ ${$self.formatNumber(ppfCalculator.variables.ppfMaturity)}`);
                const ppfMaturityUpdatedHeading = $(el).find(ppfCalculator.variables.ppfMaturityHeading).html().replace(ppfCalculator.variables.ppfuserName, `<span class="text-blue-500">${firstName}</span>`);
                $(el).find(ppfCalculator.variables.ppfMaturityHeading).html(ppfMaturityUpdatedHeading);
                $self.createGraphData(ppfDuration, ppfAmount, ppfTime, ppfROI);
                $self.createGraph(el);
            });
            /* eslint-disable @typescript-eslint/no-this-alias */
        },
        calculatePPF: function (periodType, principalAmount, duration, roi) {
            const interest = roi;
            const tenure = duration;
            principalAmount = this.removeCommas(principalAmount);
            const principal = principalAmount;
            const selectedPeriod = periodType.toLowerCase();
            let A = principal;
            let r = parseFloat(interest / 100);
            let n = periodType === 'yearly' ? 15 : periodType === 'half-yearly' ? 6 : periodType === 'quarterly' ? 4 : 12;
            let t = tenure;
            let M = 0;
            if (selectedPeriod == 'yearly') {
                M = A * ((Math.pow((1 + r), n)) - 1) * ((1 + r) / r);
            } else if (selectedPeriod === 'half-yearly') {
                let balance = 0;
                for (let i = 1; i <= tenure; i++) {
                    for (let j = 1; j <= 2; j++) {
                        balance = (balance + parseInt(principal));
                        let intr = (r * balance) / 2;
                        M = M + parseInt(principal) + intr;
                    }
                    balance = M;
                }
            } else if (selectedPeriod == 'quarterly') {
                let balance = 0;
                for (let i = 1; i <= tenure; i++) {
                    for (let j = 1; j <= 4; j++) {
                        balance = (balance + parseInt(principal));
                        let intr = (r * balance) / 4;
                        M = M + parseInt(principal) + intr;
                    }
                    balance = M;
                }
            } else if (selectedPeriod == 'monthly') {
                let balance = 0;
                for (let i = 1; i <= tenure; i++) {
                    for (let j = 1; j <= 12; j++) {
                        balance = (balance + parseInt(principal));
                        let intr = (r * balance) / 12;
                        M = M + parseInt(principal) + intr;
                    }
                    balance = M;
                }
            }
            return Math.ceil(M);
        },
        createGraphData: function (periodType, principalAmount, duration, ppfROI) {
            const { variables: { ppfLabels, ppfPrincipal, ppfInterest } } = ppfCalculator;
            let r = parseFloat(ppfROI) / 100;
            periodType=periodType.toLowerCase();
            let n = periodType === 'yearly' ? 1 : periodType === 'half-yearly' ? 6 : periodType === 'quarterly' ? 4 : 12;
            let lastBarCompoundAmount = 0;
            const graphLength = duration / 5;
            principalAmount = this.removeCommas(principalAmount)
            for (let i = 1; i <= duration; i++) {
                ppfLabels.push(i);
                let tenr = i,
                    year = i;
                let cmpndAmount = 0,
                    cmpndInterest = 0,
                    principalValue = 0;


                let A = principalAmount;
                let months = year * 12;
                if (periodType == 'yearly') {

                    cmpndAmount = A * ((Math.pow((1 + r), tenr)) - 1) * ((1 + r) / r);
                    principalValue = (principalAmount * tenr);

                }
                else if (periodType == 'half-yearly') {
                    let balance = 0;
                    for (let i = 1; i <= tenr; i++) {
                        for (let j = 1; j <= 2; j++) {
                            balance = (balance + parseInt(principalAmount));
                            let intr = (r * balance) / 2;
                            cmpndAmount = cmpndAmount + parseInt(principalAmount) + intr;
                        }
                        balance = cmpndAmount;
                    }
                    principalValue = (principalAmount * (tenr * 2))


                }
                else if (periodType == 'quarterly') {
                    let balance = 0;
                    for (let i = 1; i <= tenr; i++) {
                        for (let j = 1; j <= 4; j++) {
                            balance = (balance + parseInt(principalAmount));
                            let intr = (r * balance) / 4;
                            cmpndAmount = cmpndAmount + parseInt(principalAmount) + intr;
                        }
                        balance = cmpndAmount;
                    }
                    principalValue = (principalAmount * (tenr * 4))


                } else {
                    let balance = 0;
                    for (let i = 1; i <= tenr; i++) {
                        for (let j = 1; j <= 12; j++) {
                            balance = (balance + parseInt(principalAmount)); //500, 1000
                            let intr = (r * balance) / 12; //3, 6
                            cmpndAmount = cmpndAmount + parseInt(principalAmount) + intr; //503, 1009
                        }
                        balance = cmpndAmount;
                    }
                    principalValue = (principalAmount * (tenr * 12));

                }

                cmpndInterest = cmpndAmount - principalValue;

                // interestArray.push(cmpndInterest.toFixed());

                if (i == duration) {
                    lastBarCompoundAmount = cmpndAmount;
                }

                if ((i) <= duration) {
                    ppfPrincipal.push(parseFloat(principalValue));
                    ppfInterest.push(cmpndInterest);
                } else {
                    ppfPrincipal.push(parseFloat(principalValue) + cmpndInterest);

                }


                var ci = lastBarCompoundAmount; //compoundAmount;
                // ci && (e = (e = Math.round(ci / 3) + "")[0] * Math.pow(10, e.length - 1));
            }
            const ppfInterestTrunc = ppfInterest.map((item) => Math.trunc(item));
            const newPPfPrincipal = this.getValuesWithGap(ppfPrincipal, graphLength - 1, graphLength);
            const newPPfInterest = this.getValuesWithGap(ppfInterestTrunc, graphLength - 1, graphLength);
            const newPPfLabels = this.getValuesWithGap(ppfLabels, graphLength - 1, graphLength).map((item) => `${item} years`);
            ppfPrincipal.length > 0 && ppfPrincipal.splice(0, ppfPrincipal.length);
            ppfPrincipal.push(...newPPfPrincipal);
            ppfInterest.length > 0 && ppfInterest.splice(0, ppfInterest.length);
            ppfInterest.push(...newPPfInterest);
            ppfLabels.length > 0 && ppfLabels.splice(0, ppfLabels.length);
            ppfLabels.push(...newPPfLabels);
        },
        createGraph: function (el) {
            const { variables: { ppfLabels, ppfPrincipal, ppfInterest, ppfGraphEl, ppfMaturity } } = ppfCalculator;
            const ctx = $(el).find(ppfGraphEl).get(0).getContext('2d');
            const ppfPrincipalText = $(el).data('principal');
            const ppfInterestText = $(el).data('interest');
            const ppfYog = $(el).data('yog');
            ppfCalculator.variables.ppfChart && ppfCalculator.variables.ppfChart.destroy();
            const magnitude = Math.floor(Math.log10(ppfMaturity / 5));
            let stepGap;
            if (magnitude >= 2 && magnitude < 3) {
                stepGap = 100;          // 100 to 999
            } else if (magnitude >= 3 && magnitude < 4) {
                stepGap = 1000;         // 1,000 to 9,999
            } else if (magnitude >= 4 && magnitude < 5) {
                stepGap = 10000; // 10,000 to 99,999
            } else if (magnitude >= 5 && magnitude < 6) {
                stepGap = 100000;          // 100,000 to 999,999
            } else if (magnitude >= 6 && magnitude < 7) {
                stepGap = 1000000;      // 1,000,000 to 9,999,999
            } else if (magnitude >= 7 && magnitude < 8) {
                stepGap = 10000000;  // 10,000,000 to 99,999,999
            } else if (magnitude >= 8 && magnitude < 9) {
                stepGap = 100000000;          // 100,000,000 to 999,999,999
            } else {
                stepGap = undefined;      // 1,000,000,000 and above
            }
            const stepSize = this.roundUpToNearestCeiling(ppfMaturity / 4, stepGap);
            ppfCalculator.variables.ppfChart = new Chart(ctx, {
                type: 'bar',
                plugins: [paddingLeftPlugin],
                data: {
                    labels: ppfLabels,
                    datasets: [
                        {
                            label: ppfPrincipalText || 'Amount Invested',
                            data: ppfPrincipal,
                            backgroundColor: '#EFAC00',
                            barPercentage: 0.3,
                            categoryPercentage: 0.7,
                            font: {
                                size: 10,
                                family: 'Satoshi',
                                weight: "bold"
                            },
                        },
                        {
                            label: ppfInterestText || 'Interest Earned',
                            data: ppfInterest,
                            backgroundColor: '#7F56D9',
                            barPercentage: 0.3,
                            categoryPercentage: 0.7,
                            font: {
                                size: 10,
                                family: 'Satoshi',
                                weight: "bold"
                            },
                        }
                    ]
                },
                options: {
                    maintainAspectRatio: false,
                    scales: {
                        y: {
                            stacked: true,
                            beginAtZero: true,
                            display: true,
                            title: {
                                display: true,
                                text: ppfPrincipalText || 'Amount Invested',
                                color: "#7A7A7A",
                                font: {
                                    size: 12,
                                    family: 'Satoshi',
                                    weight: "bold"
                                },
                            },
                            grid: {
                                display: true,
                                drawBorder: false,
                                drawTicks: false
                            },
                            ticks: {
                                callback: function (value) {
                                    return value >= 1000 ? (value / 1000) + 'k  ' : value;
                                },
                                stepSize: stepSize,
                                color: "#0067B1",
                                font: {
                                    family: "Satoshi",
                                    weight: "normal",
                                }
                            },
                        },
                        x: {
                            stacked: true,
                            border: {
                                display: true,
                            },
                            grid: {
                                display: false,
                            },
                            title: {
                                display: true,
                                text: ppfYog || 'Year of Growth',
                                color: "#7A7A7A",
                                font: {
                                    size: 12,
                                    family: 'Satoshi',
                                    weight: "bold"
                                },
                            },
                            ticks: {
                                font: {
                                    family: "Satoshi",
                                    weight: "normal",
                                },
                                color: "#0067B1",
                            },
                        }
                    },
                    plugins: {
                        paddingLeft: {},
                        legend: {
                            display: true,
                            position: 'top',
                            align: 'start',
                            labels: {
                                padding: 15,
                                font: {
                                    size: "13",
                                    color: "#000000"
                                },
                                generateLabels: function (chart) {
                                    const datasets = chart.data.datasets;
                                    return datasets.map((dataset, i) => ({
                                        text: `  ${dataset.label}`,
                                        fillStyle: 'transparent',
                                        strokeStyle: dataset.backgroundColor,
                                        hidden: !chart.isDatasetVisible(i),
                                        lineWidth: 4,
                                        datasetIndex: i,
                                    }));
                                },
                                usePointStyle: true,
                                textDecoration: (ctx) => ctx.hidden ? 'line-through' : ''
                            },
                        },
                        tooltip: {
                            callbacks: {
                                label: function (tooltipItem) {
                                    return tooltipItem.dataset.label + ': ' + `₹${tooltipItem.raw.toLocaleString()}`;
                                }
                            }
                        }
                    }
                }
            });

        },
        getValuesWithGap: function (arr, startIndex, gap) {
            const slicedArray = arr.slice(startIndex);

            const result = slicedArray.filter((_, index) => index % gap === 0);

            return result;
        },
        roundUpToNearestCeiling: function (value, step) {
            // Calculate the ceiling value
            return Math.ceil(value / step) * step;
        },
        removeCommas: function (inputString) {
            return inputString.replace(/,/g, '');
        },
        reCalculate: function (el) {
            const $el = $(el);
            const { variables: { ppfCalculatorReset, ppfLabels, ppfPrincipal, ppfInterest } } = ppfCalculator;
            $el.find(ppfCalculatorReset).on(CONSTANT.eventsListners.CLICK, function () {
                $el.find('[data-page="1"]').removeClass('d-none');
                $el.find('[data-page="2"]').addClass('d-none');
                ppfLabels.length && ppfLabels.splice(0, ppfLabels.length);
                ppfPrincipal.length && ppfPrincipal.splice(0, ppfPrincipal.length);
                ppfInterest.length && ppfInterest.splice(0, ppfInterest.length);
            })

        },
        init: function () {
            this.createDropDown(ppfCalculator.variables.ppfCalculatorWrapper);
             $('.ppf__calculator--reset').on('click', function(e){
                  var obj = ppfCalculator.methods.ppfObj(e);
                  createDataLayer('buttonClick', obj);
              })
              $('.ppf__calculator--calculate').on('click', function(e){
                  var obj = ppfCalculator.methods.ppfObj(e);
                  createDataLayer('buttonClick', obj);
              })
              $('.ppf__calculator--submit').on('click', function(e){
                let name=$(this).closest('.ppfCalculator').find('.ppf__calculator--name').val();
                // may be absent when {phoneNumber} is not authored
                let mobileNumber=$(this).closest('.ppfCalculator').find('.ppf__calculator--mob').val() || '';
                  var obj = ppfCalculator.methods.ppfObj(e,name,mobileNumber);
                  createDataLayer('buttonClick', obj);
              })
          },
          ppfObj : function(e,name,mobileNumber) {
              var obj = {
                  'articleName' : "",
                  'blogCategory' : "",
                  'blogPageCategory' : "",
                  'buttonText' : e.currentTarget.innerText.replace(/\n/g, '').trim(),
                  'pageSection' : "PPF Calculator",
                  'pageType' : document.querySelector("meta[name='template']").content == 'chli-base-page-template' ? window.location.href.includes("blog") ? "Blogs" : window.location.href.substring(window.location.href.indexOf(".com/"), window.location.href.length) === ".com/" ? "Home" : "Other Pages" : "Blog Details Page",
                  'planOption' : "",
                  'productCategory' : "",
                  'productName' : "",
                  'question' : "",
                  'source' : "",
                  'searchTerm' : "",
                  'videoTitle' : "",
                  'bannerName' : "",
                  'name': name ? name: "",
                  'mobileNumber': mobileNumber ? mobileNumber: "",
                  "countryCode" : "+91",
              }
              return obj;
        }
    }
};

$(() => {
    if ($(ppfCalculator.variables.ppfCalculatorWrapper).length) {
        ppfCalculator.methods.init();
    }
});
export default ppfCalculator;
